import { takeLatest, put, call, select } from 'redux-saga/effects';
import { initialize } from 'redux-form';

import * as act from '../../actions';
import * as actNotif from '../../actions/notifications';
import * as actSalesTypeHub from '../../actions/businessLibrary/salesType';
import * as salesTypeHubConstant from '../../actions/businessLibrary/salesType/constants';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';

import * as apiSalesTypeHub from '../../api/businessLibrary/salesType';
import * as apiProfile from '../../api/profile';
import { assertErrorHasMessage } from '../../utils/assert';

const getSalesTypeHubState = (state) => state.businessLibrary.salesTypeHub;

function* fillFormSalesTypeDetail(salesTypeDetail) {
  const formSalesTypeDetail = {
    id: salesTypeDetail.id,
    name: salesTypeDetail.name,
  };

  yield put(initialize('salesTypeHub', formSalesTypeDetail));
}

export function* pageRequest() {
  yield put(showPageLoadingSpinner(true));
  yield put(actSalesTypeHub.setSalesTypeDetail(null));
  yield put(actSalesTypeHub.closeRightColumn());
  yield put(act.showProgressBar());

  const params = {
    page: 0,
    size: 25,
    keyword: '',
  };

  try {
    const resProfile = yield call(apiProfile.getProfile);
    const salesTypeHub = yield call(apiSalesTypeHub.getListSalesType, params);
    yield put(
      actSalesTypeHub.setGratuityStatusFromSetting(
        resProfile.data.business.setting.enable_gratuity
      )
    );
    yield put(actSalesTypeHub.setListSalesType(salesTypeHub.data.results));
    yield put(
      actSalesTypeHub.setMetaSalesType({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        total_pages: salesTypeHub.data.total_pages - 1,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        total_count: salesTypeHub.data.total_count,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        current_page: params.page,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onClickCreateSalesTypeFlow() {
  yield put(actSalesTypeHub.setSalesTypeDetail(null));
  yield call(fillFormSalesTypeDetail, {
    id: null,
    name: null,
  });
  yield put(actSalesTypeHub.openRightColumn());
}

export function* createSalesType(request) {
  const {
    payload: { data },
  } = request;

  yield put(act.showProgressBar());
  yield put(actSalesTypeHub.isSubmittingForm(true));
  try {
    yield put(
      actSalesTypeHub.setEventAsyncJob(
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_CREATE_CHANNEL
      )
    );
    yield call(apiSalesTypeHub.postSalesTypeHub, data);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    yield put(actSalesTypeHub.isSubmittingForm(false));
  }
}

export function* onClickCancel() {
  yield put(actSalesTypeHub.setSalesTypeDetail(null));
  yield call(fillFormSalesTypeDetail, [
    {
      id: null,
      name: null,
    },
  ]);
  yield put(actSalesTypeHub.closeRightColumn());
}

export function* onClickRow(request) {
  const {
    payload: { salesType },
  } = request;

  try {
    yield put(act.showProgressBar());
    const resSalesTypeDetail = yield call(
      apiSalesTypeHub.getSalesTypeDetail,
      salesType.id
    );
    const salesTypeDetail = resSalesTypeDetail.data;
    const currentSalesType = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      active_state: salesTypeDetail.active_state,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      business_id: salesTypeDetail.business_id,
      id: salesTypeDetail.id,
      name: salesTypeDetail.name,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      outlet_id: salesTypeDetail.outlet_id,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      synchronized_at: salesTypeDetail.synchronized_at,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      updated_at: salesTypeDetail.updated_at,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      is_advance_ordering: salesTypeDetail.is_advance_ordering,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      has_business_level_entity: salesTypeDetail.has_business_level_entity,
    };
    yield put(actSalesTypeHub.setSalesTypeDetail(currentSalesType));
    yield call(fillFormSalesTypeDetail, currentSalesType);
    yield put(actSalesTypeHub.openRightColumn());
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* updateSalesType(request) {
  const {
    payload: { values },
  } = request;

  yield put(act.showProgressBar());
  yield put(actSalesTypeHub.isSubmittingForm(true));
  try {
    yield put(
      actSalesTypeHub.setEventAsyncJob(
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_UPDATE_CHANNEL
      )
    );
    yield call(apiSalesTypeHub.putItemById, values.id, values);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    yield put(actSalesTypeHub.isSubmittingForm(false));
  }
}

export function* deleteSalesTypeRequest(request) {
  const {
    payload: { deletedSalesType },
  } = request;
  yield put(actSalesTypeHub.setDeletedSalesType(deletedSalesType));
  yield put(actSalesTypeHub.showDeleteModal());
}

export function* deleteSalesType(request) {
  const {
    payload: { deletedSalesType },
  } = request;
  yield put(act.showProgressBar());
  yield put(actSalesTypeHub.isSubmittingForm(true));
  try {
    yield put(
      actSalesTypeHub.setEventAsyncJob(
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_DELETE_CHANNEL
      )
    );
    yield call(apiSalesTypeHub.deleteSalesTypeHub, deletedSalesType.id);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actSalesTypeHub.hideDeleteModal());
    yield put(actNotif.error(error.message));
    yield put(actSalesTypeHub.isSubmittingForm(false));
  }
}

export function* salesTypeRequest(action) {
  const {
    payload: { params, previousSalesType },
  } = action;
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiSalesTypeHub.getListSalesType, params);
    const sales = previousSalesType.concat(response.data.results);
    yield put(actSalesTypeHub.setListSalesType(sales));
    yield put(
      actSalesTypeHub.setMetaSalesType({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        total_pages: response.data.total_pages - 1,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        total_count: response.data.total_count,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        current_page: params.page,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* handleSuccessAsyncJob(request) {
  const {
    payload: { resourceId },
  } = request;
  const { salesType, salesTypeDetail, eventAsyncJob } = yield select(
    getSalesTypeHubState
  );
  let newSalesType;
  try {
    if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_CREATE_CHANNEL
    ) {
      const respSalesTypeDetail = yield call(
        apiSalesTypeHub.getSalesTypeDetail,
        resourceId
      );
      newSalesType = [...salesType];
      newSalesType.unshift(respSalesTypeDetail.data);
      yield call(fillFormSalesTypeDetail, {
        id: respSalesTypeDetail.data.id,
        name: respSalesTypeDetail.data.name,
      });
      yield put(actSalesTypeHub.setSalesTypeDetail(respSalesTypeDetail.data));
      yield put(actNotif.success('Sales Type was successfully saved.'));
    } else if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_DELETE_CHANNEL
    ) {
      newSalesType = salesType.filter(
        (sales) => sales.id !== salesTypeDetail.id
      );
      yield put(actSalesTypeHub.setSalesTypeDetail(null));
      yield put(actSalesTypeHub.setDeletedSalesType(null));
      yield put(actSalesTypeHub.hideDeleteModal());
      yield put(actSalesTypeHub.closeRightColumn());
      yield put(actNotif.success('Sales Type was successfully removed.'));
    } else if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_UPDATE_CHANNEL
    ) {
      const respSalesTypeDetail = yield call(
        apiSalesTypeHub.getSalesTypeDetail,
        resourceId
      );
      newSalesType = [];
      salesType.forEach((sales) => {
        if (sales.id === salesTypeDetail.id) {
          newSalesType.push({
            id: respSalesTypeDetail.data.id,
            name: respSalesTypeDetail.data.name,
          });
        } else {
          newSalesType.push(sales);
        }
      });
      yield put(actNotif.success('Sales Type was successfully saved.'));
      yield put(actSalesTypeHub.setSalesTypeDetail(respSalesTypeDetail.data));
      yield call(fillFormSalesTypeDetail, {
        id: respSalesTypeDetail.data.id,
        name: respSalesTypeDetail.data.name,
      });
    }
    yield put(actSalesTypeHub.setListSalesType(newSalesType));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actSalesTypeHub.isSubmittingForm(false));
    yield put(act.hideProgressBar());
    yield put(actSalesTypeHub.setEventAsyncJob(null));
  }
}

export function* handleFailedAsyncJob(request) {
  const {
    payload: { errorMessage },
  } = request;
  yield put(actSalesTypeHub.setEventAsyncJob(null));
  yield put(actNotif.error(errorMessage || 'Failed process sales type'));
  yield put(actSalesTypeHub.isSubmittingForm(false));
}

export default function* saga() {
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_PAGE_REQUEST,
    pageRequest
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_ON_CLICK_CREATE_SALES,
    onClickCreateSalesTypeFlow
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_ON_CLICK_CANCEL,
    onClickCancel
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_CREATE,
    createSalesType
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_ON_CLICK_ROW,
    onClickRow
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_UPDATE,
    updateSalesType
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_DELETE_SALES_REQUEST,
    deleteSalesTypeRequest
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_DELETE_SALES,
    deleteSalesType
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_SALES_TYPE_REQUEST,
    salesTypeRequest
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_HANDLE_SUCCESS_ASYNC_JOB,
    handleSuccessAsyncJob
  );
  yield takeLatest(
    salesTypeHubConstant.LIBRARY_SALES_TYPE_HUB_HANDLE_FAILED_ASYNC_JOB,
    handleFailedAsyncJob
  );
}
